import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20dark%20gaming%20atmosphere%20with%20crimson%20and%20gold%20gradient%2C%20abstract%20geometric%20pattern%20background%2C%20cinematic%20lighting%20with%20dramatic%20rays%2C%20immersive%20digital%20art%2C%20professional%20game%20website%20banner%2C%20no%20text&width=1800&height=600&seq=cta-bg-gaming-02&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-black/60"></div>
      <div className="relative max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading text-white mb-4">
          准备好开始你的游戏之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-[550px] mx-auto">
          加入黄游网页版，200+精品游戏等你来探索，无需下载，即刻畅玩！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/role-playing"
            className="px-8 py-3.5 bg-primary-500 text-white text-base font-medium rounded-md hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            免费开始游戏
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-white/15 text-white text-base font-medium rounded-md hover:bg-white/25 transition-all duration-300 backdrop-blur-sm whitespace-nowrap cursor-pointer"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}